/**
 * One short sentence for a target that did not resolve, in the customer's
 * words: the resolver's closed reason set (`services/targets/resolver.py`)
 * plus `unavailable`, which the server writes when the targets read itself
 * failed (`services/targets/picture_target.py::REASON_UNAVAILABLE`).
 *
 * Split out of `react/ComparisonRows.tsx::rowReasonSentence` (plan 2026-10-05
 * finance chart types, A2) because the bullet draws the same sentences from
 * the PURE entry, which may not import from `./react`. Both read this one
 * map, so a card's target row and a bullet never word the same reason two
 * ways.
 *
 * The reason itself is never shown: an unknown value gets the default
 * sentence, so a server-side string can never reach the page.
 */
export function targetReasonSentence(
  reason: string | null | undefined,
  /** The metric's lines lie outside the selected period (plan 2026-10-11
   *  dashboard target empty state, B1/D1): the miss is the period. */
  linesRange?: { start: string; end: string } | null,
): string {
  if (reason === "no_line" && linesRange) return "No target for this period";
  switch (reason) {
    case "unavailable":
      // Asked for and did not arrive. Never "no target": a failure must not
      // read like a plan without a line (ADR-0269).
      return "The target could not be loaded";
    case "no_version":
      // Not the D1 chip's words: there is no active plan at all.
      return "No active target plan";
    case "no_line":
      return "No target for this metric";
    case "partial_coverage":
      return "Target covers part of the period";
    case "level_never_rolls_up":
      return "Target is set at a level that does not roll up to this view";
    default:
      return "No target for this period";
  }
}
